import React from 'react'
import { bool } from 'prop-types'

const showAdapter = (Component) => {
  const WithShow = ({ show, ...rest }) => {
    if (!show) return null
    return <Component {...rest} />
  }
  WithShow.propTypes = {
    show: bool,
  }
  WithShow.defaultProps = {
    show: true,
  }
  return WithShow
}

export default showAdapter



// WEBPACK FOOTER //
// ./shared/util/element/adapters/show.js